import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  ViewEncapsulation,
  ContentChild,
  TemplateRef,
  ViewChild,
  EventEmitter,
  HostListener,
  forwardRef,
} from '@angular/core';

import { DroppableDirective } from '../../directives/ngx-droppable.directive';
import { FormBuilderHelper } from '../../../shared/helper';
import { BuilderService } from '../../services/builder.service';

let i = 0;
function getNextId() {
  return i++;
}

/**
 * Component that allows nested ngxDroppable and ngxDraggables
 */
@Component({
  selector: 'ngx-dnd-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss', '../item/item.component.scss', '../../../fb/components/FormTab/form-tab.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ContainerComponent implements OnInit, AfterViewInit {

  @Input()
  get dropZones() {
    return this._dropZones || this._defaultZones;
  }
  set dropZones(val) {
    this._dropZones = val;
  }

  constructor(public builderService: BuilderService) {}

  get hasRows() {
    if (this.disabled || !this.modelContainer) {
      return;
    }
    return this.modelContainer.rows;
  }

  get canMoveDown() {
    if (this.disabled || !this.hasRows) {
      return;
    }
    return this.modelContainer.rows[this.modelIndex + 1];
  }

  get canMoveUp() {
    if (this.disabled || !this.hasRows) {
      return;
    }
    return this.modelIndex !== 0;
  }
  @Input() disabled: boolean;
  @Input() isTemplate: boolean;
  @Input() modelIndex: any;
  @Input() modelContainer: any;
  @Input() activeModel;
  @Input() model: any;
  @Input() copy = false;
  @Input() removeOnSpill = false;
  @Input() droppableItemClass: string | ((o: any) => any);

  @Input() dropZone = `@@DefaultDropZone-${getNextId()}@@`;

  @Input() moves: (model: any, source: any, handle: any, sibling: any) => boolean;

  @Input()
  @ContentChild(TemplateRef, { static: false })
  template: TemplateRef<any>;

  @Input()
  @ViewChild(forwardRef(() => DroppableDirective), { static: false })
  droppable: any;

  @Output()
  drop: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  drag: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  over: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  out: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  remove: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  cancel: EventEmitter<any> = new EventEmitter<any>();

  @Output('onTemplateAdded') templateAddEvent = new EventEmitter<any>();
  @Output('onTemplateDeleted') templateDeleteEvent = new EventEmitter<any>();

  _dropZones: string[];
  _defaultZones: string[];

  private _formBuilderHelper = new FormBuilderHelper();

  @HostListener('click')
  onClick() {
    this.builderService.setFocus(this.modelContainer);
  }

  ngOnInit() {
    this._defaultZones = [this.dropZone];
  }

  ngAfterViewInit() {
    this.droppable.drag.subscribe((v: any) => this.drag.emit(v));
    this.droppable.drop.subscribe((v: any) => this.drop.emit(v));
    this.droppable.over.subscribe((v: any) => this.over.emit(v));
    this.droppable.out.subscribe((v: any) => this.out.emit(v));
    this.droppable.remove.subscribe((v: any) => this.remove.emit(v));
    this.droppable.cancel.subscribe((v: any) => this.cancel.emit(v));
  }

  generateDropZone(item) {
    if (item.cells || (item.template && item.template.cells)) {
      return 'builder-new-row';
    }
    return this.dropZone;
  }

  generateDropZones(item) {
    if (item.cells || (item.template && item.template.cells)) {
      return ['builder-new-row'];
    }
    return this.dropZones;
  }

  shouldMove() {
    return !this.disabled;
  }

  export() {
    if (!this.hasRows) {
      return;
    }
    this.templateAddEvent.emit({ cells: this.model });
  }

  templateDeleted(template) {
    this.templateDeleteEvent.emit(template);
  }

  itemClass(item) {
    let cssClass = 'ngx-dnd-item';
    if (item && item.rowSpan) {
      cssClass += ` fb-forced-columns-${item.rowSpan}`;
    }
    return cssClass;
  }

  addNew() {
    if (this.disabled || !this.hasRows) {
      return;
    }
    this.modelContainer.rows.splice(this.modelIndex + 1, 0, { cells: [] });
  }

  delete() {
    if (this.disabled || !this.hasRows) {
      return;
    }
    if (this.modelContainer.rows.length === 1) {
      alert('Cannot delete all the rows inside container. Delete container if needed.');
      return;
    }
    this.modelContainer.rows.splice(this.modelIndex, 1);
  }

  moveDown() {
    if (!this.canMoveDown) {
      return;
    }
    this._formBuilderHelper.move(this.modelContainer.rows, this.modelIndex, this.modelIndex + 1);
  }

  moveUp() {
    if (!this.canMoveUp) {
      return;
    }
    this._formBuilderHelper.move(this.modelContainer.rows, this.modelIndex, this.modelIndex - 1);
  }
}
